import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PastDueInfo } from '../modal-content';
import { PaymentMethodModalService } from '../../../settings/billing/payment-method/payment-method-modal.service';

@Component({
    selector: 'app-past-due-balance',
    imports: [CommonModule],
    templateUrl: './past-due-balance.component.html',
    styleUrl: './past-due-balance.component.scss'
})
export class PastDueBalanceComponent {
    activeModal = inject(NgbActiveModal);
    private paymentModals = inject(PaymentMethodModalService);

    @Input() pastDue: PastDueInfo | undefined;

    get balance(): number {
        return this.pastDue?.pastDueBalance ?? 0;
    }

    get daysUntilSuspension(): number | null | undefined {
        return this.pastDue?.daysUntilSuspension;
    }

    get showSuspensionCountdown(): boolean {
        return this.daysUntilSuspension !== null && this.daysUntilSuspension !== undefined;
    }

    /**
     * The action CTAs stack their modal on top of this one instead of dismissing
     * it, so a customer who closes the action without finishing lands back on
     * the warning and has to dismiss it explicitly. A saved card is the
     * exception: it answers the warning, so this goes with it (DEV-10988).
     */

    viewInvoices() {
        this.paymentModals.openInvoiceHistory({ unpaidOnly: true });
    }

    updatePaymentMethod() {
        const paymentMethodModal = this.paymentModals.openEditPaymentMethod();

        paymentMethodModal.closed.subscribe((result: { saved?: boolean } | undefined) => {
            if (result?.saved) this.activeModal.close({ action: 'paymentUpdated' });
        });
    }

    dismiss() {
        this.activeModal.close({ action: 'dismiss' });
    }
}
